<template>
  <v-card>
    <slot name="title">
      <v-card-title primary-title>
        {{title}}
      </v-card-title>
    </slot>
    <div id="container" ref="container" :style="{height:height+'px'}">
    </div>
    <slot name="actions" :cancel="cancel" :submit="submit">
      <v-card-actions v-show="ShowActions">
        <v-spacer></v-spacer>
        <v-btn color="info" flat @click="cancel">取消</v-btn>
        <v-btn color="success" @click="submit">确定</v-btn>
      </v-card-actions>
    </slot>
  </v-card>
</template>

<style scoped>
  #container {

    text-align: left;

  }
</style>

<script>
  import GhCodeEditor from "./ghCodeEditor.ts";
  export default GhCodeEditor;
</script>